<div class="w-dvw h-dvh flex flex-row gap-2 bg-surface-50">
  <div class="h-full w-auto py-3 pl-3">
    <app-sidebar></app-sidebar>
  </div>
  <main class="size-full flex flex-col gap-2 overflow-hidden py-3 pr-3">
    <section class="min-h-0 h-full w-full block">
      <router-outlet></router-outlet>
    </section>
  </main>
</div>
